import { FormatValue, NumberFormatOptionsType } from '../types';

import { DEFAULT_OPTIONS, toFixed } from '../utils';

export const formatNumber = (
  value: FormatValue,
  options?: NumberFormatOptionsType,
): string => {
  let decimals = options?.decimals ?? DEFAULT_OPTIONS.decimals;
  const decimalPoint = options?.decimalPoint ?? DEFAULT_OPTIONS.decimalPoint;
  const thousandsSeparator = options?.thousandsSeparator ?? DEFAULT_OPTIONS.thousandsSeparator;
  const skipTruncate = options?.skipTruncate ?? DEFAULT_OPTIONS.skipTruncate;
  const useMathParse = options?.useMathParse ?? DEFAULT_OPTIONS.useMathParse;

  const valueWithCorrectDecimalPoint = value.toString()
    .replace(/,/g, '.')
    .replace(/[^0-9+\-.]/g, '');

  if (decimals < 0) {
    console.error(`format -> decimals cannot be less than zero. Current value = ${decimals}`);
    decimals = Math.abs(decimals);
  }

  let float: string[];

  if (useMathParse) {
    float = toFixed(valueWithCorrectDecimalPoint, decimals)
      .toString()
      .split('.');
  }
  else {
    const splitted = valueWithCorrectDecimalPoint.split('.');
    const fraction = splitted[1];

    if (fraction) {
      splitted[1] = fraction.substring(0, decimals);
    }

    float = splitted;
  }

  if (float[0].length > 3) {
    float[0] = float[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeparator);
  }

  const fraction = float[1] || '';

  if (skipTruncate && fraction.length < decimals) {
    float[1] = fraction;
    float[1] += new Array(decimals - fraction.length + 1).join('0');
  }

  return float.join(decimalPoint);
};

/**
 * Format odd/price value.
 */
